import type { ReactElement } from "react";

/**
 * The single, standardized placeholder character used to represent an empty,
 * missing or unavailable value in the UI.
 */
export const EMPTY_VALUE_PLACEHOLDER = "-";

/**
 * Renders the standardized empty-value placeholder.
 *
 * Use this everywhere a missing/empty value needs to be displayed instead of
 * hand-writing a muted dash. For pure string contexts (where JSX cannot be
 * used) fall back to {@link EMPTY_VALUE_PLACEHOLDER}.
 */
export function EmptyValue(): ReactElement {
  return <span className="text-muted-foreground">{EMPTY_VALUE_PLACEHOLDER}</span>;
}
